module.exports = __webpack_public_path__ + "static/media/api.92f55c68.svg";